export default __webpack_public_path__ + "static/media/bb2.0592684d.mp4";